/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';

import useStyles from './styles';

const AccredationLevel = ({ accreditationLevel, cardList = false }) => {
  const accredite = accreditationLevel;
  const styles = useStyles();

  return (
    <div css={[styles.ratingContainer(cardList)]}>
      {[...Array(accredite)].map((data, index) => {
        return <div key={index} css={styles.star(cardList)} />;
      })}
    </div>
  );
};
AccredationLevel.propTypes = {
  accreditationLevel: PropTypes.number,
};
export default AccredationLevel;
